function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024.16 1024.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 150,
    style: {
      fill: "#143232"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.85,
    y: 310.69,
    width: 269.87,
    height: 402.62,
    rx: 50,
    style: {
      fill: "#dcd7c8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "578.86 413.49 581.38 399.44 494.94 399.44 492.41 413.49 520.87 413.49 486.29 610.51 460.72 610.51 458.2 624.56 544.64 624.56 547.17 610.51 518.71 610.51 553.29 413.49 578.86 413.49",
    style: {
      fill: "#143232"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.68,624a159,159,0,0,1-19.09,1.8q-7.4,0-17.65-7.11t-20.53-22.06q-19.27-29.18-51.15-81.77H772.53V615h27v8.64h-72V615h27V407.16h-27v-8.64H801q31.51,0,49.44,14T868.34,454q0,16.58-8,29.09a60.44,60.44,0,0,1-21.61,20.17,85.39,85.39,0,0,1-30.35,10q14.4,22,25.3,38.18t24.59,35.12q9.36,13.15,16.65,20t12.79,9.19a31.82,31.82,0,0,0,11.62,2.52ZM772.53,407.16v97.26h22.69q26.29,0,39.09-12.34t12.78-35.21q0-49.71-46.11-49.71Z",
    transform: "translate(0)",
    style: {
      fill: "#dcd7c8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.32,468H303.4q-1.62-26.66-6.31-39.53t-13.5-17.12q-8.82-4.22-25.58-4.23H242.53V615H276v8.64H191V615h33.5V407.16H209q-16.93,0-25.66,4.14t-13.42,17q-4.69,12.89-6.31,39.72h-7.92V398.52h155.6Z",
    transform: "translate(0)",
    style: {
      fill: "#dcd7c8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobileLogo.8b41ed4302550317d285f7de52e90d80.svg";
export { ForwardRef as ReactComponent };